import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../../data/offer';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-amber-400 text-[#0A1B33] shadow-sm transition-[background-color,transform] hover:bg-amber-300 active:scale-[0.98] focus-visible:ring-amber-400/50',
    secondary: 'bg-white text-slate-900 border border-slate-300 shadow-sm transition-[background-color,transform] hover:bg-slate-50 active:scale-[0.98] focus-visible:ring-slate-400/40',
    outline: 'border border-teal-700 bg-transparent text-teal-700 transition-colors hover:bg-teal-50 focus-visible:ring-teal-500/40'
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-4 text-base sm:px-10 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold duration-150 ease-out focus:outline-none focus-visible:ring-4 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    const handleClick = () => {
      if (href === checkoutUrl) window.fbq?.('track', 'InitiateCheckout');
      onClick?.();
    };
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} onClick={handleClick} data-id="element-194" data-mp="xnqs8mvlk4bf">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-195" data-mp="1cf94c9lc5epi" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-196" data-mp="17geongio069m">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-197" data-mp="1lbqg9f1ixgmb" />}
    </button>;
}